import { CheckIcon } from '@heroicons/react/20/solid';
import cn from './cn.js';

/**
 * Steps: horizontal wizard progress with labels.
 * steps: [{ name, status: 'complete' | 'current' | 'upcoming' }]
 * onStepClick(index) is only called for completed steps.
 */
export default function Steps({ steps = [], onStepClick, className, compact = false }) {
  return (
    <nav aria-label="Progress" className={cn('w-full', className)}>
      <ol className="flex items-center">
        {steps.map((step, index) => {
          const last = index === steps.length - 1;
          const clickable = step.status === 'complete' && onStepClick;
          return (
            <li key={step.name || index} className={cn('relative flex items-center', !last && 'flex-1')}>
              <button
                type="button"
                onClick={() => clickable && onStepClick(index)}
                disabled={!clickable}
                className={cn('group flex items-center gap-2.5 rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500', clickable ? 'cursor-pointer' : 'cursor-default')}
                aria-current={step.status === 'current' ? 'step' : undefined}
              >
                <span
                  className={cn(
                    'inline-flex shrink-0 items-center justify-center rounded-full text-xs font-semibold transition-colors',
                    compact ? 'h-6 w-6' : 'h-7 w-7',
                    step.status === 'complete' && 'bg-indigo-600 text-white group-hover:bg-indigo-500',
                    step.status === 'current' && 'bg-white text-indigo-600 ring-2 ring-indigo-600',
                    step.status === 'upcoming' && 'bg-white text-gray-400 ring-1 ring-gray-300',
                  )}
                >
                  {step.status === 'complete' ? <CheckIcon className="h-4 w-4" aria-hidden="true" /> : index + 1}
                </span>
                {!compact && (
                  <span className={cn('hidden whitespace-nowrap text-sm font-medium sm:block', step.status === 'current' ? 'text-gray-900' : step.status === 'complete' ? 'text-gray-700' : 'text-gray-400')}>
                    {step.label || step.name}
                  </span>
                )}
              </button>
              {!last && <span className={cn('mx-3 h-px flex-1 rounded', step.status === 'complete' ? 'bg-indigo-600' : 'bg-gray-200')} aria-hidden="true" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
